<!--
 * @Author:
 * @Description:
 * @Date: 2025-01-08 16:08:48
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-checkout-web/src/components/policy/index.vue
-->
<!-- 订单详情组件 -->
<template>
  <div class="policy">
    <span>{{ $t('message.checkout.policy.prefix') }}</span>
    <span @click="viewPolicy" class="btn">{{ $t('message.checkout.privacy') }}</span>
    <span>{{ $t('message.checkout.policy.suffix') }}</span>
  </div>
</template>
<script>
export default {
  name: 'policy',

  // computed: {
  //     orderGetter() {
  //         return this.order;
  //     }
  // },
  data() {
    return {

    };
  },
  methods: {
    viewPolicy() {
      this.$emit('viewPolicy');
    },
  },
  mounted() {

  },
};
</script>
<style lang="scss" scoped>
.policy {
  height: 16px;
  overflow: hidden;
  text-align: center;
  font-size: 12px;
  padding: 0;
  color: #8D98AF;
  text-align: center;
  margin-bottom: 24px;

  .btn {
    text-decoration: underline;
    cursor: pointer;
    color: #8D98AF;
    &:hover {
      color: #1A202C;
    }
  }
}
</style>
